import { KEYS } from 'game/constants/SceneConstants';
import GameSceneBase from './GameSceneBase';
import { GameTimer } from '../../display/ui/games/GameTimer';
import { OnboardingPointer } from '../../display/ui/OnboardingPointer';

const ZONES = [
  {
    water: 3,
    hitarea: { x: 500, y: 350, width: 95, height: 125 },
    spine: 'water_saviour_bath',
    animations: { on: 'on', off: 'off' },
    character: { x: 550, y: 600, id: 'gumball' },
  },
  {
    water: 1,
    hitarea: { x: 610, y: 250, width: 90, height: 150 },
    spine: 'water_saviour_jar_1',
    animations: { on: 'off', off: 'on' },
    character: { x: 675, y: 580, id: 'gumball' },
  },
  {
    water: 1,
    hitarea: { x: 1075, y: 250, width: 90, height: 150 },
    spine: 'water_saviour_jar_2',
    animations: { on: 'off', off: 'on' },
    character: { x: 1150, y: 575, id: 'darwin' },
  },
  {
    water: 3,
    hitarea: { x: 740, y: 250, width: 125, height: 200 },
    spine: 'water_saviour_shower',
    animations: { on: 'on', off: 'off' },
    character: { x: 755, y: 580, id: 'gumball' },
  },
  {
    water: 2,
    hitarea: { x: 340, y: 370, width: 125, height: 100 },
    spine: 'water_saviour_sink_bathroom',
    animations: { on: 'on', off: 'off' },
    character: { x: 420, y: 600, id: 'gumball' },
  },
  {
    water: 2,
    hitarea: { x: 900, y: 350, width: 125, height: 100 },
    spine: 'water_saviour_sink_kitchen',
    animations: { on: 'on', off: 'off' },
    character: { x: 960, y: 610, id: 'darwin' },
  },
];

const OBJECT_TRIGGER_TIME = { min: 1000, max: 2000 };
const GAME_TIME_LIMIT = 30000;

export default class WaterSaviour extends GameSceneBase {
  constructor() {
    super({ key: KEYS.WaterSaviour, active: false });
  }

  create() {
    super.create();
    this.gameRunning = false;
    this.timelimit = GAME_TIME_LIMIT;
    // spines
    this.spineBG = this.add.spine(840, 360, 'water_saviour_game_background', '', false);
    this.interactives = ZONES.map((zone) => this.addInteractiveZone(zone));

    // characters
    this.gumball = this.add.spine(650, 600, 'water_saviour_gumball', 'down', true);
    this.gumball.homePosition = { x: this.gumball.x, y: this.gumball.y };
    this.darwin = this.add.spine(1030, 600, 'water_saviour_darwin', 'down', true);
    this.darwin.homePosition = { x: this.darwin.x, y: this.darwin.y };

    // time display
    this.gameClock = new GameTimer(this, 550, 0);
    // this.gameClock.setTimePercent(0);
    this.onboardingPointer = new OnboardingPointer(this, {
      tapPositions: this.interactives.map((i) => ({
        x: i.x + i.width * 0.5,
        y: i.y + i.height * 0.5,
      })),
    });

    // water meter
    this.meterbg = this.add.renderTexture(750, 100, 500, 50).setOrigin(0, 0.5).fill(0x000000, 0.5);
    this.meter = this.add.renderTexture(750, 100, 500, 50).setOrigin(0, 0.5).fill(0x0000ff, 1);
    this.meterbg.visible = false;
    this.meter.visible = false;
    this.setUpGame();
  }

  addInteractiveZone(config) {
    const zone = this.add
      .zone(config.hitarea.x, config.hitarea.y, config.hitarea.width, config.hitarea.height)
      .setOrigin(0);
    zone.spine = this.add.spine(this.spineBG.x, this.spineBG.y, config.spine, '', true);
    zone.config = config;
    zone.id = config.spine;
    zone.state = 'on';
    zone.on('pointerdown', () => this.handleSelectInteractive(zone), this);

    return zone;
  }

  setUpGame() {
    this.gameClock.visible = false;
    this.timelimit = GAME_TIME_LIMIT;
    // triger intro aniamtions
    this.gumball.setScale(0);
    this.darwin.setScale(0);
    this.spineBG.once('complete', this.showInstruction, this);
    this.spineBG.play('in');
    this.spineBG.on('event', this.handleSpineEvent, this);

    this.interactives.forEach((i) => i.spine.play('in'));
    this.tweens.add({
      targets: [this.gumball, this.darwin],
      scale: 1,
      duration: 250,
      ease: Phaser.Math.Easing.Back.Out,
      delay: 1250,
    });
  }

  handleSpineEvent(t, e) {
    if (e.data?.name === 'sfx') {
      switch (e.stringValue) {
        case 'page_open':
          this.game.soundController.playSFX('general', 'general_page_open');
          break;
        case 'page_close':
          this.game.soundController.playSFX('general', 'general_page_close');
          break;
        case 'page_popup':
          this.game.soundController.playSFX('general', 'general_popup');
          break;
      }
    }
  }

  showInstruction() {
    super.showInstruction(this.game.copy.get('WaterSaviour_instruction'), this.startGame, this);
  }

  startGame() {
    // set base start
    this.waterLevel = 0;
    this.meter.scaleX = 0;
    this.gameClock.enter();
    this.gameClock.visible = true;
    this.meterbg.visible = true;
    this.meter.visible = true;
    this.waterSFX = this.game.soundController.playSFX('watersaviour', 'water_running', {
      loop: true,
    });

    this.interactives.forEach((i) => {
      i.state = 'on';
      i.spine.play(i.config.animations.on, true);
    });

    this.meter.scaleX = 0;
    this.onboardingPointer.enable();

    // water timer
    this.timerNextObjectTrigger = 0;
    this.enableInteractiveZones(true);
    this.gameClock.once('complete', () => (this.gameRunning = true), this);
  }

  enableInteractiveZones(value) {
    this.interactives.forEach((i) =>
      value ? i.setInteractive({ useHandCursor: true }) : i.removeInteractive()
    );
  }

  update(t, delta) {
    if (!this.gameRunning) return;

    this.interactives.forEach((interactive) => this.updateInteractive(interactive, delta));
    this.meter.scaleX = this.waterLevel / 100;

    this.timerNextObjectTrigger -= delta;
    if (this.timerNextObjectTrigger <= 0) this.handleNextObjectTrigger();

    this.timelimit -= delta;
    this.gameClock.setTimePercent(this.timelimit / GAME_TIME_LIMIT);
    if (this.timelimit < 0 || this.waterLevel >= 100) this.handleGameEnd();
  }

  handleNextObjectTrigger() {
    const options = this.interactives.filter((i) => i.state === 'off');
    if (options?.length) {
      const interactive = options[Math.floor(Math.random() * options.length)];
      interactive.state = 'on';
      interactive.spine.play(interactive.config.animations.on, true);
      // this.timerNextObjectTrigger = Math.max(
      //   OBJECT_TRIGGER_TIME.min,
      //   OBJECT_TRIGGER_TIME.max * (this.timelimit / GAME_TIME_LIMIT)
      // );
      this.timerNextObjectTrigger =
        Math.random() * (OBJECT_TRIGGER_TIME.max - OBJECT_TRIGGER_TIME.min) +
        OBJECT_TRIGGER_TIME.min;
      this.updateWaterSFX();
    }
  }

  handleSelectInteractive(interactive) {
    if (interactive.state === 'on') {
      const characterSpine = this[interactive.config.character.id];
      if (!characterSpine || characterSpine.busy) return;
      characterSpine.x = interactive.config.character.x;
      characterSpine.y = interactive.config.character.y;
      characterSpine.busy = true;
      characterSpine.play('up');
      interactive.state = 'off';
      characterSpine.timer = this.time.delayedCall(350, () => {
        this.resetCharacter(characterSpine);
      });

      if (interactive.config.spine.includes('jar')) {
        this.game.soundController.playSFX('watersaviour', 'water_jar');
      } else {
        this.game.soundController.playSFX('watersaviour', 'water_tap_off');
      }

      interactive.spine.play(interactive.config.animations.off, true);
    }

    this.updateWaterSFX();
  }

  updateWaterSFX() {
    if (!this.waterSFX) return;

    const interactiveON = this.interactives.find((i) => i.state === 'on');

    const map = this.interactives.map((i) => i.state === 'on');

    this.interactives.forEach((i) => {
      if (i.state === 'on') {
        this.on = i.id;
      }
    });

    console.log(map, this.waterSFX.isPlaying, this.on);

    if (interactiveON && !this.waterSFX.isPlaying) {
      this.waterSFX.resume();
      console.log('water on');
    } else if (!interactiveON && this.waterSFX.isPlaying) {
      this.waterSFX.pause();
      console.log('water off');
    }
  }

  resetCharacter(character) {
    character.play('down');
    character.x = character.homePosition.x;
    character.y = character.homePosition.y;
    character.busy = false;
    if (character.timer) {
      character.timer.remove();
      character.timer = null;
    }
  }

  updateInteractive(interactive, delta) {
    // const dir = interactive.state === 'off' ? 1 : -1;
    if (interactive.state === 'off') {
      const water = interactive.config.water * (delta / 1000);
      this.waterLevel = Math.max(0, Math.min(100, this.waterLevel + water));
    }
  }

  handleGameEnd() {
    this.waterSFX.stop();
    this.gameRunning = false;
    this.onboardingPointer.disable();
    this.enableInteractiveZones(false);
    this.gameClock.exit();
    this.resetCharacter(this.gumball);
    this.resetCharacter(this.darwin);

    const didWin = this.timelimit > 0;
    if (didWin) this.closeGame(true, this.timelimit > GAME_TIME_LIMIT * 0.66 ? 3 : 2);
    else this.closeGame(false, this.waterLevel > 50 ? 1 : 0);
  }

  closeGame(win, stars) {
    this.game.soundController.stopMusic('music');
    this.spineBG.once('complete', () => this.showEndGameScreen(win, stars));
    this.spineBG.play(win ? 'win' : 'lose');
    if (win) {
      this.game.soundController.playSFX('general', 'general_success', {
        delay: 1.2,
      });
      this.game.soundController.playSFX('watersaviour', 'water_success', { delay: 3.7 });
    } else if (!win) {
      this.game.soundController.playSFX('general', 'general_fail', {
        delay: 1.2,
      });
      this.game.soundController.playSFX('watersaviour', 'water_fail', { delay: 2.2, loop: true });
    }

    this.interactives.forEach((i) => i.spine.play('out'));

    this.meter.visible = this.meterbg.visible = false;
    this.tweens.add({
      targets: [this.gumball, this.darwin],
      scale: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Back.In,
    });
  }

  restartGame() {
    this.setUpGame();
  }

  shutdown() {
    this.game.soundController.stopAllSFX();
    super.shutdown();
    this.game.unloadGame(KEYS.KeepOutTheCold);
  }
}
